import { render, staticRenderFns } from "./GiftPackage.vue?vue&type=template&id=046c57a3&"
import script from "./GiftPackage.vue?vue&type=script&lang=js&"
export * from "./GiftPackage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports